<script>
export default {
  data () {
    return {
      windowWidth: 0,
      windowHeight: 0
    }
  },
  computed: {
    isMobile () {
      return this.windowWidth <= 499.9
    }
  },
  created () {
    const handler = () => {
      this.windowWidth = window.innerWidth
      this.windowHeight = window.innerHeight
    }
    document.addEventListener('visibilitychange', handler)
    window.addEventListener('DOMContentLoaded', handler)
    window.addEventListener('resize', handler)
    window.dispatchEvent(new Event('resize'))
  }
}
</script>



// WEBPACK FOOTER //
// src/mixins/responsitive.vue